export default {
  address: {
    "GB": {
      requiredFields: ['street', 'streetNumber', 'city', 'postCode']
    },
    "PL": {
      requiredFields: ['street', 'streetNumber', 'city']
    },
    "RU": {
      requiredFields: ['street', 'streetNumber', 'city']
    },
    "RO": {
      requiredFields: ['street', 'streetNumber', 'city'],
    },
    "CZ": {
      requiredFields: ['street', 'streetNumber', 'city']
    },
    "SK": {
      requiredFields: ['street', 'streetNumber', 'city']
    },
    "HR": {
      requiredFields: ['street', 'streetNumber', 'city']
    },
    "DE": {
      requiredFields: ['street', 'streetNumber', 'city']
    },
    "NL": {
      requiredFields: ['street', 'streetNumber', 'city']
    },
    "BR": {
      requiredFields: ['street', 'streetNumber', 'city']
    }
  }
}
